import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetClient(clientId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/client/" + clientId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetClients(start, limit, options = {}) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/client/",
        params: { start, limit, ...options },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetClientBillingEntities() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/client/billingEntities",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetClientAccounts(clientId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/client/" + clientId + "/accounts",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateClient(client) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/client/",
        data: client,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateClient(clientId, updates) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/client/" + clientId,
        data: updates,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestActivateClient(clientId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/client/" + clientId + "/activate",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeactivateClient(clientId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/client/" + clientId + "/deactivate",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteClient(clientId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/client/" + clientId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRestoreClient(clientId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/client/" + clientId + "/restore",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetUnbilledCharges(clientId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/client/" + clientId + "/unbilled-charges",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAddClientDocument(clientId, document) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/client/" + clientId + "/documents",
        data: document,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateClientDocument(clientId, docId, updates) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/client/" + clientId + "/documents/" + docId,
        data: updates,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteClientDocument(clientId, docId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/client/" + clientId + "/documents/" + docId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRequestClientDocumentCopy(clientId, docId) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/client/" + clientId + "/documents/" + docId + "/request-copy",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetClientDocuments(params) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/client/documents",
        params,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetClientDocumentScopes(clientId, search) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/client/" + clientId + "/documents/scopes",
        params: search ? { search } : {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetClientDocumentTypes() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/client/documents/types",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAddClientDocumentChange(clientId, docId, change) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/client/" + clientId + "/documents/" + docId + "/changes",
        data: change,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateClientDocumentChange(clientId, docId, changeId, updates) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/client/" + clientId + "/documents/" + docId + "/changes/" + changeId,
        data: updates,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteClientDocumentChange(clientId, docId, changeId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/client/" + clientId + "/documents/" + docId + "/changes/" + changeId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestContactClient(clientId, data) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/client/" + clientId + "/contact",
        data,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetClientFixedPriceRates() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/client/fixed-price-rates",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSetClientFixedPriceRate(clientId, fixedPriceRate) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/client/" + clientId + "/fixed-price-rate",
        data: { fixedPriceRate },
        withCredentials: true,
        crossorigin: true,
    });
}
